export default __webpack_public_path__ + "static/media/expert-avatar.024c563c.png";